import type { Rank } from './types';

export const rankMap: Rank[] = [
  { rank: 'Neutral Newbie', points: 0 },
  { rank: 'Clutched', points: 25 },
  { rank: '1st Gear', points: 50 },
  { rank: '2nd Gear', points: 100 },
  { rank: '3rd Gear', points: 250 },
  { rank: '4th Gear', points: 500 },
  { rank: '5th Gear', points: 1000 },
  { rank: '6th Gear', points: 2500 },
  { rank: 'Supercharged', points: 5000 },
  { rank: 'Turbocharged', points: 7500 },
  { rank: 'Nos-ed', points: 15000 },
  { rank: '2Fast2Furious', points: 25000 },
  { rank: 'Ludicrous Mode', points: 50000 },
];
